import {Component, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import {ProjectsService} from '../../../core/projects.service';
import {MapService} from '../../../../../shared/services/map.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../../state/app.state';
import {SetQPForMap} from '../../../core/projects.actions';
import {qpForMap} from '../../../core/projects.selectors';

@Component({
    selector: 'app-map-wrapper',
    templateUrl: './map-wrapper.component.html',
    styleUrls: ['./map-wrapper.component.scss'],
    standalone: false
})
export class MapWrapperComponent implements OnDestroy {
  private readonly onDestroy: Subject<any> = new Subject<any>();
  isFullScreen = false;
  existingQueryParams: any = {};
  showButtons = true;

  constructor(
    private store: Store<fromRoot.State>,
    private route: ActivatedRoute,
    private router: Router,
    private projectsService: ProjectsService,
    private mapService: MapService,
  ) {
    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        this.isFullScreen = 'fs' in qp;
      });

    this.mapService.showWrapperButtons
      .pipe(takeUntil(this.onDestroy))
      .subscribe(show => {
        this.showButtons = show;
      });

    this.mapService.triggerFullScreenToggle.pipe(takeUntil(this.onDestroy))
      .subscribe(show => {
        if (show) {
          this.openInFullScreen();
        } else {
          this.closeMap();
        }
      });
  }

  zoomIn() {
    this.mapService.triggerZoomIn.next();
  }

  zoomOut() {
    this.mapService.triggerZoomOut.next();
  }

  closeMap() {
    this.store.select(qpForMap)
    .pipe(
      map(result => {
        // Preserve date-related params from current URL when exiting fullscreen
        const currentQP = this.route.snapshot.queryParams;
        return {
          ...result,
          date: currentQP.date,
          reportId: currentQP.reportId,
          // Preserve startDate and endDate from current URL if they exist
          startDate: currentQP.startDate || result.startDate,
          endDate: currentQP.endDate || result.endDate
        };
      })
    )
    .subscribe(modifiedResult => {
      this.router.navigate([], {
        queryParams: modifiedResult
      });
    }).unsubscribe();
  }

  openInFullScreen() {
    this.store.dispatch(SetQPForMap({
      qpForMap: this.route.snapshot.queryParams
    }));
    this.router.navigate([], {
      queryParams: {
        fs: 1
      },
      queryParamsHandling: 'merge'
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
